module.exports = __webpack_public_path__ + "img/cathaven.22b6687.png";